import { AppSidebar } from "@/components/common/app-sidebar";
import Header from "@/components/common/header";
import LoadingSpinner from "@/components/common/pages/loading-spinner";
import NotFound from "@/components/common/pages/not-found";
import { SidebarInset, SidebarProvider } from "@/components/ui/sidebar";
import WhatsAppReconnectGate from "@/components/whatsapp-reconnect-modal/gate";
import { Outlet, createFileRoute, redirect } from "@tanstack/react-router";

function getStoredSupplierRole() {
  try {
    const storedUser = localStorage.getItem("openfarming.auth.user");
    return storedUser ? JSON.parse(storedUser)?.supplierRole : null;
  } catch {
    return null;
  }
}

function isWarehouseAllowedPath(pathname: string) {
  return (
    pathname === "/" ||
    pathname === "/orders" ||
    pathname === "/orders/" ||
    pathname === "/products" ||
    pathname === "/products/" ||
    (
      pathname.startsWith("/orders/") &&
      !pathname.startsWith("/orders/upload") &&
      !pathname.startsWith("/orders/generate-invoice")
    )
  );
}

export const Route = createFileRoute("/_main")({
  component: RouteComponent,
  beforeLoad: async ({ context, location }) => {
    const authenticated = await context.auth.checkAuthentication();
    if (!authenticated) {
      throw redirect({
        to: "/sign-in",
        search: {
          redirect: location.href,
        },
      });
    }
    const supplierRole =
      context.auth.user?.supplierRole ?? getStoredSupplierRole();
    if (
      supplierRole === "warehouse_user" &&
      !isWarehouseAllowedPath(location.pathname)
    ) {
      throw redirect({
        to: "/",
      });
    }
  },
  notFoundComponent: () => <NotFound />,
  pendingComponent: () => (
    <div className="flex h-screen items-center justify-center">
      <LoadingSpinner size={50} />
    </div>
  ),
  pendingMs: 25,
});

function RouteComponent() {
  return (
    <div className="flex h-screen flex-col">
      <SidebarProvider>
        <AppSidebar />
        <SidebarInset>
          <Header />
          <WhatsAppReconnectGate />
          <Outlet />
        </SidebarInset>
      </SidebarProvider>
    </div>
  );
}
